import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { hideMobileAppPopup } from '../../../redux/ui/popup';
import brandConfig, { isFlagler } from '../../../constants/brandConfig';
import MobileAppLogo from '../../MobileAppLogo';
import Button from '../../Button';
import Icon from '../../Icon';
import styles from './styles.styl';

function MobileAppModal() {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const skip = () => dispatch(hideMobileAppPopup());

  return (
    <div className={styles.root}>
      <Icon
        size={98}
        name={brandConfig.logo}
        style={{ ...(isFlagler && { fill: brandConfig.fillColor }) }}
      />
      <p className={styles.title}>
        {formatMessage({ id: 'mobile.app.title' })}
      </p>
      <MobileAppLogo className={styles.socialApps} />
      <p className={styles.meta}>
        {formatMessage(
          { id: 'mobile.app.getAppText' },
          { name: brandConfig.name },
        )}
      </p>
      <Button onClick={skip} color="primary" className={styles.btn} raised>
        {formatMessage({ id: 'common.skip' })}
      </Button>
    </div>
  );
}

export default MobileAppModal;



// WEBPACK FOOTER //
// ./src/components/Ui/MobileAppModal/index.jsx